import { useNavigate } from "react-router-dom";

import { Models } from "api/types";
import { Icon } from "atoms/icon/Icon";
import ChevronRightSmall from "atoms/icon/icons/ic_chevron_right_small_ol.svg";

export const GiftCardInclusionDetails = ({
  giftCards,
}: {
  giftCards: Models<"InclusionModel">[];
}) => {
  const navigate = useNavigate();
  const navigationPath = "/shop/gift-cards";

  return (
    <li>
      <button
        onClick={() => navigate(navigationPath)}
        className="flex w-full justify-between py-[1px] pl-5"
        aria-label={`Navigate to ${giftCards[0].name}`}
      >
        <span className="mr-2 flex min-w-0 flex-1 flex-wrap gap-1">
          {giftCards[0].giftCardValues?.map((giftCardValue, idx) => (
            <span key={giftCardValue} className="whitespace-nowrap text-left">
              ${giftCardValue / 100}
              {idx < (giftCards[0].giftCardValues?.length ?? 0) - 1 && ","}
            </span>
          ))}
        </span>
        <Icon
          svg={ChevronRightSmall}
          size="xsmall"
          color="brandColor"
          className="flex-shrink-0"
        />
      </button>
    </li>
  );
};
